export default __webpack_public_path__ + "static/media/Co2EmissionIcon.e14aa3e1.svg";